import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { take, tap } from "rxjs/operators";
import { BaseResponse } from "src/app/models/base-response.model";
import { SearchTableParam } from "src/app/models/base-search.model";
import { AuthService } from "../services/auth.service";
import {
  SiteCreate,
  SiteUpdate,
  SiteSearch,
  SitesListRespone,
  SiteResponse,
  SiteGetAllResponse,
  SiteCulture,
  SiteCultureGetAllResponse,
} from "./models/data-models";
import { SiteHostName } from "./models/host-name.models";
import { SiteSetting } from "./models/site-setting.models";


@Injectable({
  providedIn: "root",
})
export class SiteService {
  private SiteChangedSubject = new Subject<boolean>();
  isSiteChanged$: Observable<boolean> = this.SiteChangedSubject.asObservable();

  private siteCultureSubject = new BehaviorSubject<
    BaseResponse<SiteCultureGetAllResponse[]>
  >(null);
  siteCulture$: Observable<
BaseResponse<SiteCultureGetAllResponse[]>
  > = this.siteCultureSubject.asObservable();

  constructor(private http: HttpClient,
    private authService: AuthService
  ) {
    // var user = this.authService.getLoggedUser();
    // setTimeout(() => {
    //   this.getSiteCultures(+user.siteId)
    //     .pipe(tap((res: BaseResponse<SiteCultureGetAllResponse[]>) => {
    //       this.siteCultureSubject.next(res);
    //     }))
    //     .subscribe();
    // }, 100);

  }

  public create(request: any) {
    return this.http.post<BaseResponse<number>>("/Sites/Create", request);
  }
  public completeAdd(request: any) {
    return this.http.post<BaseResponse<number>>(
      "/Sites/CompleteAddSite",
      request
    );
  }
  public addSiteCultures(request: any[]) {
    console.log(request);

    return this.http.post<BaseResponse<boolean>>(
      
      "/Sites/AddSiteCultures",
      request
    );
  }
  public getSites() {
    return this.http.get("/Sites/GetAllSites");
  }
  public addSiteCulture(request: any) {
    return this.http.post<BaseResponse<boolean>>("/SiteCulture/Add", request);
  
  }
  public addSiteHostName(request: any) {
    console.log(request)
    return this.http.post<BaseResponse<number>>(
      "/Sites/AddSiteHostName",
      request
    );
  }
  public editSiteHostName(request: any) {
    return this.http.post<BaseResponse<boolean>>(
      "/Sites/EditSiteHostName",
      request
    );
  }
  public addSiteSetting(request: any) {
    return this.http.post<BaseResponse<boolean>>(
      "/Sites/AddSiteSettings",
      request
    );
  }
  public editSiteSetting(request: any) {
    return this.http.post<BaseResponse<boolean>>(
      "/Sites/EditSiteSettings",
      request
    );
  }
  public update(request: any) {
    return this.http.post<BaseResponse<number>>("/Sites/Edit", request);
  }
  public getList(request: any) {
    return this.http.post("/Sites/GetList", request);
  }
  public getAllPages() {
    return this.http.post("/Pages/GetAllPages",{});
  }
  public getCoreCompanies() {
    return this.http.get(
      "/EskaCoreIntegrationApi/GetAllCompanies"
    );
  }
  public getAddresses() {
    return this.http.get("/UserAdress/GetAllAddresses");
  }
  public get(id: number) {
    return this.http.get<any>(`/Sites/GetSiteDetails/${id}`);
  }
  public delete(id: number) {
    return this.http.delete<BaseResponse<number>>(`/Sites/DeleteSite/${id}`);
  }
  public deleteSiteCulture(id: number) {
    return this.http.get<BaseResponse<number>>(`/SiteCulture/Delete?Id=${id}`);
  }
  public deleteHost(id: number) {
    return this.http.get<BaseResponse<boolean>>(`/Sites/DeleteSiteHost/${id}`);
  }
  public deleteSetting(id: string) {
    return this.http.get<BaseResponse<boolean>>(
      `/Sites/DeleteSiteSettings/${id}`
    );
  }
  public setSiteAsDefault(site: SiteResponse) {
    return this.http.post<BaseResponse<boolean>>(
      `/Sites/SetSiteAsDefault`,
      site
    );
  }
  public getAll() {
    return this.http.get<BaseResponse<any>>(`/Sites/GetAll`);
  }
  public getSiteCultures(siteId?: number) {
    // let url = `/SiteCulture/GetCulturesBySiteId`;
    // url = siteId? `/SiteCulture/GetCulturesBySiteId/`: url;
    return this.http.get<BaseResponse<SiteCultureGetAllResponse[]>>(
      `/SiteCulture/GetCulturesBySiteId/${siteId}`
    );
  }
  
  public getUsedCulturs(siteId?: number) {
       return this.http.get<SiteCultureGetAllResponse[]>(`/Sites/GetUsedSiteCultures/${siteId}`)
    .pipe(
      // tap(res => res && this.siteCultureSubject.next(res))
    );
  }

  public getAllCultures() {
    return this.http.get<BaseResponse<any[]>>(
      `/currency/get-used-cultures`
    );
  }

  public updateSitesChanged() {
    this.SiteChangedSubject.next(true);
  }
}
